import axios from 'axios'

export const httpReassignTask = (adminAccessToken, taskId, payload) => {
    return axios.post(`/admin/tasks/${taskId}/reassign`, payload, {
        headers: {
            Authorization: `Bearer ${adminAccessToken}`
        }
    })
}
